import React, { FC, useEffect, useState } from 'react';

interface InputProps {
  disabled?: boolean;
  delay?: number;
  type: string;
  id?: string;
  className?: string;
  style?: Record<string, unknown>;
  value?: any;
  name?: string;
  min?: number;
  max?: number;
  onChange?: (value: any) => void;
  onBlur?: (value: any) => void;
}

export const Input: FC<InputProps> = (props): JSX.Element => {
  const [value, setValue] = useState<any>(undefined);

  useEffect(() => {
    if (value !== props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  useEffect(() => {
    let timeout: undefined| NodeJS.Timeout = undefined;
    if (value !== undefined && value !== props.value) {
      timeout = setTimeout(() => {
        props.onChange?.(value);
      }, props.delay || 0);
    }
    return () => clearTimeout(timeout);
  }, [value]);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(event.target.value);
  }

  const handleOnBlur = (): void => {
    props.onBlur?.(value);
  }

  return (
    <input
      disabled={props.disabled}
      style={props.style}
      className={props.className}
      defaultValue={props.value}
      type={props.type}
      id={props.id}
      name={props.name}
      min={props.min}
      max={props.max}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
    />
  );
};
